var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M-26 25C-26 -57.8427 41.1573 -125 124 -125C206.843 -125 274 -57.8427 274 25C274 107.843 206.843 175 124 175C41.1573 175 -26 107.843 -26 25Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "groupLetter",
    transform: "translate(0 -10.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "W",
    transform: "translate(26 125)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 10.142045)",
    id: "W",
    fill: "#757575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24716 40.6875L0.894886 10.142L4.65341 10.142L11.0369 35.0199L11.3352 35.0199L17.8381 10.142L22.0142 10.142L28.517 35.0199L28.8153 35.0199L35.1989 10.142L38.9574 10.142L30.6051 40.6875L26.7869 40.6875L20.0455 16.3466L19.8068 16.3466L13.0653 40.6875L9.24716 40.6875Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "S",
    transform: "translate(137 223)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 10.142045)",
    id: "S",
    fill: "#757575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4034 17.7784Q20.1349 15.5114 18.2259 14.2585Q16.3168 13.0057 13.5426 13.0057Q10.5 13.0057 8.65057 14.445Q6.80114 15.8842 6.80114 18.0767Q6.80114 19.7173 7.80788 20.7241Q8.81463 21.7308 10.1942 22.2901Q11.5739 22.8494 12.7074 23.1477L15.8097 23.983Q17.0028 24.2962 18.4719 24.848Q19.941 25.3999 21.2908 26.3469Q22.6406 27.294 23.5206 28.7706Q24.4006 30.2472 24.4006 32.3949Q24.4006 34.8707 23.1104 36.8693Q21.8203 38.8679 19.3519 40.0462Q16.8835 41.2244 13.3636 41.2244Q8.44176 41.2244 5.5483 38.8977Q2.65483 36.571 2.38636 32.8125L6.20455 32.8125Q6.35369 34.5426 7.37536 35.6687Q8.39702 36.7947 9.97053 37.3391Q11.544 37.8835 13.3636 37.8835Q15.4815 37.8835 17.1669 37.19Q18.8523 36.4964 19.8366 35.2511Q20.821 34.0057 20.821 32.3352Q20.821 30.8139 19.9709 29.8594Q19.1207 28.9048 17.7337 28.3082Q16.3466 27.7116 14.7358 27.2642L10.9773 26.1903Q7.39773 25.1612 5.30966 23.2521Q3.22159 21.343 3.22159 18.2557Q3.22159 15.6903 4.61612 13.7738Q6.01065 11.8572 8.37465 10.7908Q10.7386 9.72443 13.6619 9.72443Q16.6151 9.72443 18.9119 10.7759Q21.2088 11.8274 22.5586 13.647Q23.9084 15.4666 23.983 17.7784L20.4034 17.7784Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "E",
    transform: "translate(247 125)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 10.142045)",
    id: "E",
    fill: "#757575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.69886 40.6875L3.69886 10.142L22.1335 10.142L22.1335 13.4233L7.39773 13.4233L7.39773 23.7443L21.179 23.7443L21.179 27.0256L7.39773 27.0256L7.39773 37.4063L22.3722 37.4063L22.3722 40.6875L3.69886 40.6875Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "N",
    transform: "translate(134 26)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 10.142045)",
    id: "N",
    fill: "#757575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9205 10.142L27.9205 40.6875L24.3409 40.6875L7.69602 16.7045L7.39773 16.7045L7.39773 40.6875L3.69886 40.6875L3.69886 10.142L7.27841 10.142L23.983 34.1847L24.2813 34.1847L24.2813 10.142L27.9205 10.142Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "GroupDeg",
    transform: "translate(26 125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248 25.4998L273 12.9997L273 37.9999L248 25.4998Z",
    id: "TriangleE",
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5 147L137 172L112 172L124.5 147Z",
    id: "TriangleS",
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000366211 25.5005L-25 38.0006L-25 13.0003L0.000366211 25.5005Z",
    id: "TriangleW",
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5 -97L112 -122L137 -122L124.5 -97Z",
    id: "TriangleN",
    fill: "#FF0000",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9448 -101.535L55.9448 -92.875",
    id: 330,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#BDBDBD",
    strokeWidth: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.53528 -48.0552L6.12497 -43.0552",
    id: 300,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#BDBDBD",
    strokeWidth: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.1103 25L-17.1103 25",
    id: 270,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.53528 98.0551L6.12497 93.0551",
    id: 240,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#BDBDBD",
    strokeWidth: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9448 151.535L55.9448 142.875",
    id: 210,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#BDBDBD",
    strokeWidth: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.472 171.323L124.472 166.323",
    id: 180,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.055 151.535L192.055 142.875",
    id: 150,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#BDBDBD",
    strokeWidth: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.535 98.0552L241.875 93.0552",
    id: 120,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#BDBDBD",
    strokeWidth: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.11 24.9999L265.11 24.9999",
    id: 90,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.535 -48L241.875 -43",
    id: 60,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#BDBDBD",
    strokeWidth: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.055 -101.535L192.055 -92.8751",
    id: 30,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#BDBDBD",
    strokeWidth: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 -121.11L124 -116.11",
    id: 0,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFD400",
    strokeWidth: 5,
    strokeLinecap: "square"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ring"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    fill: "#ffffff",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassWhite);
export default __webpack_public_path__ + "static/media/compassWhite.b4c9abaec2cd6642ad0c91f0f8752abf.svg";
export { ForwardRef as ReactComponent };